import { render, staticRenderFns } from "./AddBackup.vue?vue&type=template&id=a66711b8&"
import script from "./AddBackup.vue?vue&type=script&lang=js&"
export * from "./AddBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports